import { Component } from "react";
import {
  getEvent,
  savePaidBooking,
  saveFreeBooking,
} from "../../actions/bookingAction";
import { notification, withRouter } from "../../utils/utility";
import { connect } from "react-redux";
import BookingStep1 from "./booking-step-1";
import BookingStep2 from "./booking-step-2";
import BookingStep3 from "./booking-step-3";
import BookingStep4 from "./booking-step-4";
import BookingStepRedirect from "./booking-step-redirect";
import "../../assets/bookingeventassets/booking.scss";
import "../../assets/bookingeventassets/calender/fonts/icomoon/style.css";
import "../../assets/bookingeventassets/calender/css/rome.css";
import "../../assets/bookingeventassets/calender/css/style.css";
import "./booking-frame.scss";

import logo from "../../assets/images/logo-new.svg";
import SideBarFootLogo from "../../assets/bookingeventassets/assets/side_bar_foot_logo.svg";
import { getDBFormatedDate, COMPANY_LOGO_BASE_URL, computeBookingEndSlot, resolvePolicyLinkUrl, stripHTMLTags } from "../../utils/utility";
import isEmpty from "../../validation/is-empty";
import Loader from "../../components/Loader/Loader";
import ErrorPage from "../errors/ErrorPage";
import { trackBookingPageViewed } from "../../utils/productAnalytics";
import { sendPostRequest } from "../../actions/app-actions";
import { getBookingThankYouRedirectUrl, shouldIncludeStaffIdInBooking } from "../../utils/bookingRedirect";
import { applyEventMarketingTools } from "../../utils/marketingTools";

/* ── Sidebar inline SVG icons ──────────────────────────────────── */
import ZoomIcon       from "../../assets/icons/zoom.svg";
import MeetIcon       from "../../assets/icons/google-meet.svg";
import TeamsIcon      from "../../assets/icons/Microsoft_Teams.svg";
import GoToIcon       from "../../assets/icons/goto_icon.svg";
import PhoneCallIcon  from "../../assets/icons/phone_call.svg";
import InPersonIcon   from "../../assets/icons/in_person_meet.svg";
import OtherIcon      from "../../assets/icons/other_meet_icon.svg";

const EmailSvg = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const PhoneSvg = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2A19.79 19.79 0 013.07 4.18 2 2 0 015 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);
const MapSvg = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);
const ClockSvg = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const UsersSvg = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
  </svg>
);
const MegaSvg = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8a2 2 0 000 4"/><path d="M6 8v4"/><path d="M3 6l15-2v12L3 14z"/>
    <path d="M6 12v4a2 2 0 004 0v-4"/>
  </svg>
);

/* Venue icon (img-based) */
const VenueImg = ({ venue }) => {
  const s = { width: 14, height: 14, objectFit: "contain" };
  if (venue === "Microsoft Teams")   return <img src={TeamsIcon}    alt="Teams"   style={s} />;
  if (venue === "Zoom")              return <img src={ZoomIcon}     alt="Zoom"    style={s} />;
  if (venue === "Google Meet")       return <img src={MeetIcon}     alt="Meet"    style={s} />;
  if (venue === "Phone Call")        return <img src={PhoneCallIcon} alt="Phone" style={s} />;
  if (venue === "In-Person Meeting") return <img src={InPersonIcon} alt="In-Person" style={{ ...s, width: 13 }} />;
  if (venue === "Go to Meeting")     return <img src={GoToIcon}     alt="GoTo"    style={{ ...s, width: 14 }} />;
  if (venue === "Others")            return <img src={OtherIcon}    alt="Other"   style={s} />;
  return <ClockSvg />;
};

class Booking extends Component {
  state = {
    isLoading: false,
    step: 1,
    event: {},
    company: {},
    paymentSettings: null,
    selectedStaffId: null,
    selectedSlot: null,
    endSlotTime: null,
    bookingDate: null,
    firstName: null,
    lastName:null,
    email: null,
    messageFromCustomer: null,
    reminderPhoneNo: null,
    inviteeGuests: [],
    questionAnswers: [],
    timezondId: "",
    timezoneValue: "",
    addOns: [],
    pricing: [],
    specialRibbon: null,
    totalPrice: 0,
    error: null,
    bookingId: null,
    thankYouRedirectUrl: null,
  };

  /**
   * on step two submit handler
   * @param {*} name
   * @param {*} email
   * @param {*} messageFromCustomer
   */
  onSubmitStepTwo = (
    firstName,
    lastName,
    email,
    messageFromCustomer,
    reminderPhoneNo,
    inviteeGuests,
    questionAnswers,
    addOns = [],
    pricing = [],
    isEventPaid = "E"
  ) => {
    const _this = this;
    this.setState(
      {
        firstName,
        lastName,
        email,
        messageFromCustomer,
        reminderPhoneNo,
        inviteeGuests,
        questionAnswers,
        addOns,
        pricing,
      },
      () => {
        if (isEventPaid === "D") {
          _this.onScheduleEvent({});
        } else {
          _this.postTempBooking();
        }
      }
    );
  };



  /**
   * on select staff
   * @param {*} staffId
   */
  onSelectStaff = (staffId) => {
    this.setState({ selectedStaffId: staffId });
  };

  /**
   * on select timezone
   */
  onSelectTimzone = (timezondId, timezoneValue) => {
    this.setState({ timezondId, timezoneValue });
  };

  /**
   * on update step
   * @param {*} step
   */
  onUpdateStep = (step) => {
    this.setState({
      step,
    });
  };

  /**
   * Show confirmation, then optional redirect flow.
   */
  onBookingComplete = (bookingStatus = "A") => {
    const { event, company } = this.state;
    const status = bookingStatus || "A";
    const thankYouRedirectUrl =
      status === "P" ? null : getBookingThankYouRedirectUrl(event, company);
    this.setState({
      thankYouRedirectUrl,
      bookingStatus: status,
      step: 4,
    });
  };

  onThankYouRedirectPhase = () => {
    this.setState({ step: 5 });
  };

  /**
   * on select slot
   * @param {*} slot
   */
  onSelectSlot = (slot) => {
    this.setState({
      selectedSlot: slot,
    });
  };

  /**
   * on calendar date select
   * @param {*} date
   */
  onSelectDate = (date) => {
    this.setState({
      bookingDate: getDBFormatedDate(new Date(date)),
    });
  };

  /**
   * save booking in temp status
   */
  postTempBooking = () => {
    const _this = this;
    const {
      firstName,
      lastName,
      email,
      messageFromCustomer,
      reminderPhoneNo,
      questionAnswers,
      selectedStaffId,
      selectedSlot,
      event,
      bookingDate,
      company,
      addOns,
      pricing,
      timezoneValue,
      inviteeGuests,
    } = this.state;

    const bookingDateTime = bookingDate + " " + selectedSlot;

    _this.setState({
      isLoading: true,
    });

    const endSlot = computeBookingEndSlot(
      bookingDate,
      selectedSlot,
      event.timeslot,
      timezoneValue
    );

    _this.setState({
      endSlotTime: endSlot,
    });

    let bookingDetails = {
        event_id: event.id,
        booking_date_time: bookingDateTime,
        start_time: selectedSlot + ":00",
        end_time: endSlot + ":00",
        message_from_customer: messageFromCustomer,
        reminder_phone_no: reminderPhoneNo,
        business_id: company.business_id,
        timezone: timezoneValue,
        email: email,
        first_name: firstName,
        last_name: lastName,
        booking_addons: [...addOns],
        booking_pricing: [...pricing],
        questions: [...questionAnswers],
        invitee_guests: inviteeGuests
    };

    if (shouldIncludeStaffIdInBooking(event, selectedStaffId)) {
        bookingDetails.staff_id = selectedStaffId;
    }

    _this.props.sendPostRequest({
      url: `/booking/post-temp-booking`,
      data: {
        ...bookingDetails,
      },
      onSuccess: (data) => {
        if (data.success) {
          _this.setState({
            isLoading: false,
            bookingId: data.data.id
          });
          _this.onUpdateStep(3);
        }
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
        });

        if (!isEmpty(error?.response?.data?.message)) {
          notification.error(error?.response?.data?.message);
        } else if (!isEmpty(error?.response?.statusText)) {
          notification.error(error?.response?.statusText);
        } else {
          notification.error("An Error occurred duing saving, please try later");
        }
      },
    });
  }

  /**
   * confirm temp booking to active booking
   * @param {*} data 
   */
  postConfirmTempBooking = (data) => {
    const _this = this;
    const {
      selectedSlot,
      event,
      bookingDate,
      company,
      timezoneValue,
      bookingId
    } = this.state;

    const bookingDateTime = bookingDate + " " + selectedSlot;
    const endSlot = computeBookingEndSlot(
      bookingDate,
      selectedSlot,
      event.timeslot,
      timezoneValue
    );

    _this.setState({
      endSlotTime: endSlot,
      totalPrice: data.totalPrice,
      isLoading: true,
    });

    let bookingDetails = {
      event_id: event.id,
      booking_id: bookingId,
      payment_method:data.paymentMethod,
      business_id: company.business_id,
      timezone: timezoneValue,
      coupon_code: data.couponCode,
      booking_date_time: bookingDateTime,
      start_time: selectedSlot + ":00",
      end_time: endSlot + ":00",
      total_price: data.totalPrice,
    };

    if (data.paymentMethod === "card") {
      bookingDetails.stripe_payment_method_id = data.stripePaymentMethodId; 
    } else if (data.paymentMethod == "paypal") {
      bookingDetails.paypal_order_id = data.paypalOrderId;
      bookingDetails.paypal_capture_id = data.paypalCaptureId;
    }
      
    _this.props.sendPostRequest({
      url: `/booking/post-confirm-temp-booking`,
      data: {
        ...bookingDetails,
      },
      onSuccess: (data) => {
        if (data.success) {
          _this.setState({
            isLoading: false
          });
          _this.onBookingComplete(data?.data?.booking_status || data?.booking_status);
        }
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
        });
        if (!isEmpty(error?.response?.data?.message)) {
          notification.error(error?.response?.data?.message);
        } else if (!isEmpty(error?.response?.statusText)) {
          notification.error(error?.response?.statusText);
        } else {
          notification.error("An Error occurred duing saving, please try later");
        }
      },
    });

  }

  /**
   * on schedule event
   * @param {*} data
   */
  onScheduleEvent = (data) => {
    const _this = this;
    const {
      firstName,
      lastName,
      email,
      messageFromCustomer,
      reminderPhoneNo,
      questionAnswers,
      selectedStaffId,
      selectedSlot,
      event,
      bookingDate,
      company,
      addOns,
      pricing,
      timezoneValue,
      inviteeGuests,
    } = this.state;

    _this.setState({
      isLoading: true,
    });

    /*
    console.log("addons", data.addOns);
    console.log("pricing", data.pricing);
    console.log("card details", data.cardDetails);
    console.log("name", name);
    console.log("email", email);
    console.log("messageFromCustomer", messageFromCustomer);
    console.log("questionAnswers", questionAnswers);
    console.log("selectedStaffId", selectedStaffId);
    console.log("selectedSlot", selectedSlot);
    console.log("booking date", bookingDate);
    */

    // calculate booking date and time
    const bookingDateTime = bookingDate + " " + selectedSlot;
    //console.log("booking date and time", bookingDateTime);

    const endSlot = computeBookingEndSlot(
      bookingDate,
      selectedSlot,
      event.timeslot,
      timezoneValue
    );

    _this.setState({
      endSlotTime: endSlot,
    });
    // save free event
    const { saveFreeBooking } = this.props;
    let bookingDetails = {
      event_id: event.id,
      booking_date_time: bookingDateTime,
      start_time: selectedSlot + ":00",
      end_time: endSlot + ":00",
      message_from_customer: messageFromCustomer,
      reminder_phone_no: reminderPhoneNo,
      business_id: company.business_id,
      timezone: timezoneValue,
      email: email,
      first_name: firstName,
      last_name: lastName,
      questions: [...questionAnswers],
      invitee_guests: inviteeGuests,
    };

    if (shouldIncludeStaffIdInBooking(event, selectedStaffId)) {
      bookingDetails.staff_id = selectedStaffId;
    }

    saveFreeBooking({
      data: {
        ...bookingDetails,
      },
      onSuccess: (data) => {
        _this.setState({
          isLoading: false,
        });
        _this.onBookingComplete(data?.booking_status);
        console.log("data", data);
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
        });
      },
    });
  };

  /**
   * execute when component inserted in dom
   */
  componentDidMount() {
    const _this = this;
    const { router, getEvent } = this.props || {};
    const { params } = router || {};
    const { slug } = params || {};

    _this.setState({ isLoading: true });

    getEvent({
      data: {
        slug,
      },
      onSuccess: function (response) {
        if (isEmpty(response.company)) {
          _this.setState({
            isLoading: false,
            error: "Company information is missing!",
          });
          return;
        }

        _this.setState({
          isLoading: false,
          event: response.event,
          company: response.company,
          specialRibbon: !isEmpty(response.special_ribbon)
            ? response.special_ribbon.special_announcement
            : null,
          paymentSettings: response.payment_settings
        });

        applyEventMarketingTools(
          response.seo,
          response.event?.event_name || response.event?.event_title
        );

        // Ticket 16 — fail-open page view (server resolves business from slug)
        trackBookingPageViewed(response.event?.event_url || slug);
      },
      onError: (error) => {
        _this.setState({
          isLoading: false,
          error: "This event is invalid or no longer available",
        });
        notification.error(error.response.data.message);
      },
    });
  }

  render() {
    const {
      step,
      event,
      company,
      selectedSlot,
      endSlotTime,
      bookingDate,
      timezoneValue,
      addOns,
      pricing,
      specialRibbon,
      totalPrice,
      isLoading,
      inviteeGuests,
      error,
      firstName,
      lastName,
      email,
      messageFromCustomer,
      bookingId,
      thankYouRedirectUrl,
      bookingStatus,
    } = this.state;
    const bookingData = { selectedSlot };

    /* ── Sidebar helpers ───────────────────────────────────── */
    const privacyPolicyUrl      = resolvePolicyLinkUrl(company.privacy_policy);
    const cancellationPolicyUrl = resolvePolicyLinkUrl(company.cancellation_policy);
    const termsUrl              = resolvePolicyLinkUrl(company.terms_and_conditions);
    const hasPolicyLinks        = privacyPolicyUrl || cancellationPolicyUrl || termsUrl;
    const isPaid                = event.is_event_paid === "E";
    const timeslot              = !isEmpty(event)
      ? (event.timeslot !== "Customized"
          ? `${event.timeslot} minutes`
          : "Customized")
      : "";
    const formatLabel           = event.event_format_id === 1
      ? "One to One"
      : (event.no_of_attendies ? `Group (up to ${event.no_of_attendies})` : "Group");

    if (error) return <ErrorPage message={error} />;

    return (
      <>
        <Loader isShowLoader={isLoading} />

        <div className="bf-page">

          {/* ── Top bar ────────────────────────────────────────── */}
          <header className="bf-topbar">
            <img src={logo} alt="MeetOcto" />
          </header>

          {/* ── Two-panel layout ───────────────────────────────── */}
          <div className="bf-layout">

            {/* ══ Sidebar ════════════════════════════════════════ */}
            <aside className="bf-sidebar">
              <div className="bf-sidebar-card">

                {/* Company banner */}
                {company.company_logo ? (
                  <img
                    className="bf-company-banner"
                    src={COMPANY_LOGO_BASE_URL + company.company_logo}
                    alt={company.company_name || "Company"}
                  />
                ) : (
                  <div className="bf-company-banner bf-company-banner--placeholder">
                    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                  </div>
                )}

                <div className="bf-sidebar-body">
                  {/* Company info */}
                  {company.company_name && (
                    <h2 className="bf-company-name">{company.company_name}</h2>
                  )}
                  {company.company_description && (
                    <p className="bf-company-desc">{company.company_description}</p>
                  )}

                  {/* Contact details */}
                  {(company.company_email || company.company_phone_no || company.company_address) && (
                    <div className="bf-contacts">
                      {company.company_email && (
                        <div className="bf-contact-row">
                          <EmailSvg />
                          <a href={`mailto:${company.company_email}`}>{company.company_email}</a>
                        </div>
                      )}
                      {company.company_phone_no && (
                        <div className="bf-contact-row">
                          <PhoneSvg />
                          <span>{company.company_phone_no}</span>
                        </div>
                      )}
                      {company.company_address && (
                        <div className="bf-contact-row">
                          <MapSvg />
                          <span>{company.company_address}</span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* ── Event info ──────────────────────────────── */}
                  {!isEmpty(event) && (
                    <div className="bf-event-section">
                      <p className="bf-event-label">You are booking</p>
                      <h3 className="bf-event-title">{event.event_name || event.event_title}</h3>

                      {event.event_description && stripHTMLTags(event.event_description).trim() && (
                        <p className="bf-event-desc">{stripHTMLTags(event.event_description)}</p>
                      )}

                      <div className="bf-event-details">
                        {timeslot && (
                          <div className="bf-event-detail">
                            <ClockSvg /><span>{timeslot}</span>
                          </div>
                        )}
                        {event.venue && (
                          <div className="bf-event-detail">
                            <VenueImg venue={event.venue} />
                            <span>{event.venue}</span>
                          </div>
                        )}
                        {event.venue_location && event.venue_location_status === "display_location_booking" && (
                          <div className="bf-event-detail">
                            <MapSvg />
                            <span>{event.venue_location}</span>
                          </div>
                        )}
                        {event.event_format_id && (
                          <div className="bf-event-detail">
                            <UsersSvg /><span>{formatLabel}</span>
                          </div>
                        )}
                        <div className="bf-event-detail">
                          <span className={`bf-price-badge ${isPaid ? "bf-price-badge--paid" : "bf-price-badge--free"}`}>
                            {isPaid ? `$${event.event_fee}` : "Free"}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Policy links */}
                  {hasPolicyLinks && (
                    <nav className="bf-policies" aria-label="Legal">
                      {privacyPolicyUrl && (
                        <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className="bf-policy-link">
                          Privacy Policy
                        </a>
                      )}
                      {cancellationPolicyUrl && (
                        <a href={cancellationPolicyUrl} target="_blank" rel="noopener noreferrer" className="bf-policy-link">
                          Cancellation Policy
                        </a>
                      )}
                      {termsUrl && (
                        <a href={termsUrl} target="_blank" rel="noopener noreferrer" className="bf-policy-link">
                          Terms &amp; Conditions
                        </a>
                      )}
                    </nav>
                  )}
                </div>

                {/* Powered by */}
                <div className="bf-powered-by">
                  <span>Powered by</span>
                  <img src={SideBarFootLogo} alt="MeetOcto" />
                </div>

              </div>
            </aside>

            {/* ══ Main content — booking steps ═══════════════════ */}
            <main className="bf-main">

              {/* Special ribbon */}
              {!isEmpty(specialRibbon) && (
                <div className="bf-ribbon">
                  <MegaSvg />
                  <span>{specialRibbon}</span>
                </div>
              )}

              {/* All booking steps wrapped in a card panel */}
              <div className="bf-step-panel">
                {step === 1 && !isEmpty(event) && (
                  <BookingStep1
                    event={event}
                    specialRibbon={specialRibbon}
                    timezoneValue={timezoneValue}
                    onSelectTimzone={this.onSelectTimzone}
                    onSelectStaff={this.onSelectStaff}
                    onSelectSlot={this.onSelectSlot}
                    onSelectDate={this.onSelectDate}
                    onUpdateStep={this.onUpdateStep}
                  />
                )}
                {step === 2 && (
                  <BookingStep2
                    specialRibbon={specialRibbon}
                    timezoneValue={timezoneValue}
                    onSubmitStepTwo={this.onSubmitStepTwo}
                    onScheduleEvent={this.onScheduleEvent}
                    onUpdateStep={this.onUpdateStep}
                    event={event}
                    data={bookingData}
                    businessId={company.business_id}
                  />
                )}
                {step === 3 && (
                  <BookingStep3
                    specialRibbon={specialRibbon}
                    onScheduleEvent={this.onScheduleEvent}
                    onUpdateStep={this.onUpdateStep}
                    onConfirmTempBooking={this.postConfirmTempBooking}
                    addOns={addOns}
                    pricing={pricing}
                    event={event}
                    firstName={firstName}
                    lastName={lastName}
                    email={email}
                    bookingId={bookingId}
                    messageFromCustomer={messageFromCustomer}
                    bookingDate={bookingDate}
                    selectedSlot={selectedSlot}
                    timezoneValue={timezoneValue}
                    paymentSettings={this.state.paymentSettings}
                  />
                )}
                {step === 4 && (
                  <BookingStep4
                    specialRibbon={specialRibbon}
                    timezoneValue={timezoneValue}
                    totalPrice={totalPrice}
                    event={event}
                    selectedSlot={selectedSlot}
                    endSlotTime={endSlotTime}
                    bookingDate={bookingDate}
                    guests={inviteeGuests}
                    bookingStatus={bookingStatus}
                    redirectUrl={thankYouRedirectUrl}
                    onConfirmationComplete={
                      thankYouRedirectUrl ? this.onThankYouRedirectPhase : null
                    }
                  />
                )}
                {step === 5 && thankYouRedirectUrl && (
                  <BookingStepRedirect redirectUrl={thankYouRedirectUrl} />
                )}
              </div>

            </main>
          </div>{/* .bf-layout */}
        </div>{/* .bf-page */}
      </>
    );
  }
}

export default connect(null, {
  getEvent,
  savePaidBooking,
  saveFreeBooking,
  sendPostRequest
})(withRouter(Booking));
